export const colors = {
  background: '#231f1e',
  foreground: '#2d2827',
  board: '#383231',
  healthBars: '#5e5554',
  selectedBorder: '#ffd750',
  selectedBackground: '#282222;',
  hintBackground: '#ffd75017;',
  buttonBackground: '#c49e26',
  logs: { move: '#d7cabf', attack: '#e2aa7a', death: '#943718', info: '#6f6f6f' }
};

export const spacing = {
  XS: '4px',
  S: '8px',
  DEFAULT: '16px',
  M: '24px',
  L: '32px',
  XL: '40px'
};

export const theme = { colors, spacing };
